import React, { useState } from 'react';
import { toast } from 'sonner';
import RecipientsInput from './RecipientsInput';

/**
 * Modal d'envoi groupé de fiches par email (Resend).
 * UN email par destinataire (confidentialité + suivi individuel) — géré côté backend.
 * onSubmit(recipients[{email,contact_id}], message) → promesse résolue en cas de succès.
 */
const SendFichesModal = ({ propertyCount, onClose, onSubmit }) => {
  const [recipients, setRecipients] = useState([]);
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    if (recipients.length === 0) {
      toast.error('Veuillez ajouter au moins un destinataire');
      return;
    }
    setSending(true);
    try {
      await onSubmit(recipients, message.trim() || null);
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-[70] p-4"
      onClick={() => !sending && onClose()}
      data-testid="send-fiches-modal"
    >
      <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-5 py-4 rounded-t-xl flex items-center justify-between">
          <div>
            <h3 className="text-base font-bold flex items-center gap-2">
              <i className="bi bi-envelope-paper" /> Envoyer {propertyCount} fiche{propertyCount > 1 ? 's' : ''} par email
            </h3>
            <p className="text-blue-100 text-xs mt-0.5">Un email distinct sera envoyé à chaque destinataire.</p>
          </div>
          <button
            onClick={onClose}
            disabled={sending}
            data-testid="send-fiches-close"
            className="text-white/90 hover:bg-white/20 rounded-lg p-1.5 disabled:opacity-50"
          >
            <i className="bi bi-x-lg text-lg" />
          </button>
        </div>

        <div className="p-5 space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-600 mb-1.5">DESTINATAIRE(S)</label>
            <RecipientsInput value={recipients} onChange={setRecipients} testId="send-fiches-recipients" />
          </div>
          <div>
            <label className="block text-xs font-bold text-slate-600 mb-1.5">MESSAGE (optionnel)</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={4}
              placeholder="Ajoutez un mot personnalisé…"
              data-testid="send-fiches-message"
              className="w-full px-3 py-2.5 border-2 border-slate-200 rounded-lg focus:border-blue-500 outline-none text-sm leading-relaxed resize-none"
            />
          </div>
        </div>

        <div className="px-5 py-3 border-t border-slate-200 bg-slate-50 flex items-center justify-end gap-2 rounded-b-xl">
          <button
            onClick={onClose}
            disabled={sending}
            data-testid="send-fiches-cancel"
            className="px-3 py-2 text-sm font-medium text-slate-700 hover:bg-white border border-slate-200 rounded-lg disabled:opacity-50"
          >
            Annuler
          </button>
          <button
            onClick={handleSend}
            disabled={sending}
            data-testid="send-fiches-submit"
            className="px-4 py-2 bg-[#0062CC] hover:bg-[#0056b3] disabled:bg-slate-300 text-white rounded-lg text-sm font-semibold flex items-center gap-2"
          >
            <i className={`bi ${sending ? 'bi-arrow-repeat animate-spin' : 'bi-send'}`} />
            {sending ? 'Envoi…' : 'Envoyer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendFichesModal;
